import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { Animate, AnimateKeyframes, AnimateGroup } from 'react-simple-animate';

export default class NotificationsList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      notifications: props.notificationsAll || [],
      isLoading: true
    };
    this.getNotifications();
  }
  getNotifications() {
    let url = "/api/v1/portal/sidebars/notifications-list";
    return fetch(url, {
      method: "GET",
      mode: "cors",
      cache: "no-cache",
      credentials: "same-origin",
      headers: {
        "Authorization": 'Bearer '+window.api_token
        ,"Accept": 'application/json'
      },
    }).
    then((responseText) => {
      let notificationsJson = responseText.json();
      notificationsJson.then((notifications) => {
        this.setState({
          notifications: notifications,
          isLoading: false
        })
      });
    });
  }
  componentDidMount() {
    Echo.
    channel('notifications').
    listen('NewNotification',
      (e) => {
        if( (e.notification.user_company_id || e.notification.job_company_id) == $('#data-compnay-id').attr('data-compnay-id') ){
          this.setState({
            notifications: [
              e.notification,
              ...this.state.notifications
            ]
          });
        }
      }
    );
  }
  render() {
    let Notifications = [];
    if (this.state.notifications.length > 0) {
      this.state.notifications.forEach(function (i) {
        Notifications.push(
          <Notification key={"notification-" + i.id} data={i}/>
        );
      });
    }
    return (
      <ul className="notifications-list">
        {
          this.state.isLoading ? (
            <li>
              <span className="add-loading-text">
                <i className="fa fa-spinner fa-pulse"></i>
              </span>
            </li>
          ) :
          Notifications
        }
      </ul>
    );
  }
}

class Notification extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      data: props.data || null,
      play: false,
    };
  }
  renderJobButton() {
    let jobButton = '';
    if (this.state.data.job_id) {
      let that = this;
      jobButton = <a href={"/jobs/view/"+this.state.data.job_id}
                     onClick={(e) => {
                       e.preventDefault();
                       that.markNotificationAsRead(
                         "/jobs/view/"+this.state.data.job_id
                       );
                     }}
      >
        <button className="btn btn-dark btn-sm">
          view job details&nbsp;&nbsp;<i className="fa fa-arrow-right"></i>
        </button>
      </a>
    }
    return jobButton;
  }
  componentDidMount() {
    this.setState({
      play: true
    });
    let notificationId = this.state.data.id;
    Echo.
    channel('notification-'+notificationId).
    listen(
      'NotificationClicked',
      (e) => {
        this.setState({
          data: e.notification
        });
      }
    );
  }
  componentWillReceiveProps(nextProps) {
    this.setState({
      data: nextProps.data
    });
  }

  markNotificationAsRead(redirectUrl) {
    let url = "/api/v1/portal/sidebars/notifications-list/mark-as-read/"+
      this.props.data.id;
    return fetch(url, {
      method: "POST",
      mode: "cors",
      cache: "no-cache",
      credentials: "same-origin",
      headers: {
        "Authorization": 'Bearer '+window.api_token
        ,"Accept": 'application/json'
      },
    }).
    then((responseText) => {
      let notificationsJson = responseText.json();
      notificationsJson.then((notification) => {
        this.setState({
          data: notification
        });
        window.location.href = redirectUrl;
      });
    });
  }

  markNotificationAsUnread() {
    let url = "/api/v1/portal/sidebars/notifications-list/mark-as-unread/"+
      this.props.data.id;
    return fetch(url, {
      method: "POST",
      mode: "cors",
      cache: "no-cache",
      credentials: "same-origin",
      headers: {
        "Authorization": 'Bearer '+window.api_token
        ,"Accept": 'application/json'
      },
    }).
    then((responseText) => {
      let notificationsJson = responseText.json();
      notificationsJson.then((notification) => {
        this.setState({
          data: notification
        });
      });
    });
  }

  render() {
    return(
      <li
        className={"notification-"+this.state.data.id+" "+
            (this.state.data.has_been_clicked ?
              "marked-as-read" : '')
          }
      >
        <Animate
          play={this.state.play}
          start={{opacity: 0}}
          end={{opacity: 1}}
        >
        <div className="profile-container">
          {(this.state.data.has_been_clicked) ?
            <button
              className="btn btn-sm btn-danger notification-unmark-as-clicked"
              onClick={(e) => {
                this.markNotificationAsUnread();
              }
            }>
              <i className="fa fa-undo"></i>
            </button>
            : ''
          }
          <img src={"/user-images/"+this.state.data.user_id}
               width="50" height="50" />
          <span>
            <a href={"/portal-admin/users/view/"+this.state.data.user_id}>
              {this.state.data.user_name}
            </a>&nbsp;
            from&nbsp;
            <a href={"/portal-admin/companies/"+
            this.state.data.user_company_short_name}>
              {this.state.data.user_company_short_name}
            </a>
          </span>
        </div>
        <div dangerouslySetInnerHTML={{__html: this.state.data.message}}></div>
        <span className="small sidebar-time">
          {this.state.data.sidebar_time}
        </span>
        <div className="small text-right sidebar-view-job-details">
          {this.renderJobButton()}
        </div>
        </Animate>
      </li>
    )
  }
}
if (document.getElementById(
  'react-component-g4-logistics-portal-sidebars-notifications-list')) {
  ReactDOM.render(<NotificationsList />,
    document.getElementById(
      'react-component-g4-logistics-portal-sidebars-notifications-list'
    )
  );
}
